<div class="data-body" [ngClass]="{'grupo': modeGroup}">

  @if (modeGroup) {
    <span>
      <div class="balance-wrapper">
        <span class="balance-text">
          @if (miembro) {
            Saldo de {{miembro.nombre}} {{miembro.apellido_1}}
          } @else {
            Saldo Total
          }
        </span>
        <a class="balance-number">{{ saldo | currency:'EUR'}}</a>
        @if (cliente == null) {
          <span class="balance-text">Tu saldo - {{ saldoMiembro | currency:'EUR'}}</span>
        }
        <div class="actions-wrapper">
          <button mat-raised-button class="retrieve-funds" (click)="retirarBtn()" [disabled]="cliente != null && cliente.id != miembro_id">Retirar</button>
          <button mat-raised-button class="add-funds" (click)="ingresarBtn()" [disabled]="cliente != null && cliente.id != miembro_id">Cargar</button>
        </div>
      </div>
    </span>
  }

  @if (!modeGroup) {
    <span>
      <div class="balance-wrapper">
        <span class="balance-text">Saldo Total</span>
        <a class="balance-number">{{ saldo | currency:'EUR'}}</a>
        <div class="actions-wrapper">
          <button mat-raised-button class="retrieve-funds" (click)="retirarBtn()">Retirar</button>
          <button tourAnchor="saldo.cargar" mat-raised-button class="add-funds" (click)="ingresarBtn()">Cargar</button>
        </div>
      </div>
    </span>
  }

  <div class="transactions-wrapper">
    <span class="transactions-text">Actividad</span>
    <div class="horizontal" (mousedown)="onMouseDown($event)" (mouseleave)="onMouseLeave()" (mouseup)="onMouseUp()">
      <div class="scroll-wrapper">
        <div class="flex" #scrollContent>
          <div class="option" (click)="onCategoryClick(null)" [ngClass]="{'selected': null === selectedCategory}">Ver Todo</div>
          <div class="option" (click)="onCategoryClick('INGRESO')" [ngClass]="{'selected': 'INGRESO' === selectedCategory}">Ingresos</div>
          <div class="option" (click)="onCategoryClick('PREMIO')" [ngClass]="{'selected': 'PREMIO' === selectedCategory}">Premio</div>
          <div class="option" (click)="onCategoryClick('PAGO')" [ngClass]="{'selected': 'PAGO' === selectedCategory}">Pagos</div>
          <div class="option" (click)="onCategoryClick('COBRO')" [ngClass]="{'selected': 'COBRO' === selectedCategory}">Transferencias</div>
          <div class="option" (click)="onCategoryClick('INFORMACION')" [ngClass]="{'selected': 'INFORMACION' === selectedCategory}">Información</div>
          <div class="option" (click)="onCategoryClick('PROMOCION')" [ngClass]="{'selected': 'PROMOCION' === selectedCategory}">Promociones</div>
        </div>
        <div class="scroll-gradient"></div>
      </div>
    </div>
    <cdk-virtual-scroll-viewport class="scroll" #scroll itemSize="25">

      <div class="top-spinner">
        @if (isLoading && movimientos.length > 0) {
          <mat-progress-spinner class="spinner" [mode]="'indeterminate'"
          [diameter]="35"> </mat-progress-spinner>
        }
        @if (errorLoadPage) {
          <button class="button" (click)="retry(true)">Volver a intentar</button>
        }
      </div>

      @for (movimiento of movimientos; track movimiento; let i = $index) {
        <div (click)="openSheet(movimiento)" class="transaction">
          <div class="transaction-header">
            <div class="transaction-date">{{movimiento.fecha | date:'dd/MM/Y | H:mm'}}</div>
            <span class="account-total-number">{{ movimiento.saldo_total | currency:'EUR'}}</span>
          </div>
          <div class="transaction-body">
            <span class="transaction-type">{{ getTitle(movimiento) }}</span>
            <div class="transaction-number" [ngClass]="{ingreso: !comprobarCobro(movimiento.importe), cobro: comprobarCobro(movimiento.importe)}">
              {{ movimiento.importe | currency:'EUR'}}
            </div>
          </div>
        </div>
      }

      <div class="bottom-spinner">
        @if (isLoading && movimientos.length > 0) {
          <mat-progress-spinner class="spinner" [mode]="'indeterminate'"
          [diameter]="35"> </mat-progress-spinner>
        }

        @if (errorLoadPage) {
          <button class="button" (click)="retry(true)">Volver a intentar</button>
        }
      </div>

    </cdk-virtual-scroll-viewport>
  </div>
</div>